'use strict';

angular.module('docketbook')
  .controller('companySettingsGroupsController', function (userService, docketService, $scope, Restangular, $window, $state, $stateParams, accessControl, $q, Upload, uuid) {
    mixpanel.track("Opened CompanySettings-Groups Desktop");

    $scope.currentUser = accessControl.currentUser();
    $scope.currentState = $state.current;
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.mode = 'list';
    $scope.view = 'list';
    $scope.groupEdit = null;
    $scope.selectedIndexContainer = { selectedIndex: 0 };
    $scope.selected = [];
    $scope.allTimezones = moment.tz.names();
    $scope.allTimeFormats = ['12HR', '24HR'];
    $scope.timeFormatDisplay = { '12HR': '12 Hour Time', '24HR': '24 Hour Time' };
    $scope.loadingGroups = false
    $scope.loadingArchiving = false

    $scope.allGroupsById = {};

    $scope.tabChanged = function (tabName) {
      $(".tabButtonsGroup").hide();
      $("#tabButtonsGroup" + tabName).show();
    }

    $scope.archiveGroup = function (group) {
      $scope.loadingArchiving = true
      const newState = !group.active

      userService.saveOrganisationGroup({ id: group.id, active: newState }, function (updatedGroup) {
        //group.active = newState
        accessControl.refreshAndGetAllowedOrganisations(function (orgsList) {
          $scope.allOrganisations = orgsList;
          for (var i = 0; i < $scope.allOrganisations.length; i++) {
            if ($scope.allOrganisations[i].id == $scope.currentOrg.id) {
              $scope.currentOrg = $scope.allOrganisations[i];
              $scope.loadGroupsList()
              $scope.loadingArchiving = false
            }
          }
          $scope.loadingGroups = false
        }, function (err) {
        });
      }, function (err) {
        swal({
          title: "Oops!",
          text: `Unable to ${newState ? 'restore' : 'archive'} group ${group.name}. Please try again later`,
          type: "error",
          confirmButtonText: "Ok, got it."
        })
        $scope.loadingArchiving = false
      })
    }

    function path(node) {
      if (node.path !== null && node.path !== undefined) {
        return node.path;
      }
      if (node.parent === null || node.parent === undefined) {
        node.path = '/' + node.id;
      } else {
        node.path = path($scope.allGroupsById[node.parent]) + '/' + node.id;
      }
      return node.path;
    }

    function namePath(node) {
      if (node.namePath !== null && node.namePath !== undefined) {
        return node.namePath;
      }
      if (node.parent === null || node.parent === undefined) {
        node.namePath = '/' + node.name;
      } else {
        node.namePath = namePath($scope.allGroupsById[node.parent]) + '/' + node.name;
      }
      return node.namePath;
    }

    $scope.loadGroupsList = function () {
      $scope.allGroups = [];
      $scope.parentGroupId = null;
      $scope.allGroupsById = {};
      $scope.rootGroupId = null;

      // get root level group first
      for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
        var thisGroup = $scope.currentOrg.groups[i];
        if (thisGroup.parent == null) {
          $scope.rootGroupId = thisGroup.id;
          $scope.parentGroupId = thisGroup.id;
        }
        $scope.allGroupsById[thisGroup.id] = thisGroup;
        $scope.allGroupsById[thisGroup.id].expanded = true;
      }

      var keys = [];

      Object.keys($scope.allGroupsById).map(function (key) {
        var group = $scope.allGroupsById[key];
        keys.push({ path: path(group), namePath: namePath(group), id: key });
      });

      keys.sort(function (a, b) {
        var apath = a.namePath;
        var bpath = b.namePath;

        // probably the best way to compare folder paths..
        return apath.localeCompare(bpath);
      });

      $scope.allGroups = keys.map(function (item) {
        return $scope.allGroupsById[item.id];  // .name; or maybe .path; ??
      });

      // add on the path level for formatting purposed
      for (var i = 0; i < $scope.allGroups.length; i++) {
        $scope.allGroups[i].pathLevel = 0;
        if ($scope.allGroups[i].path) {
          var level = $scope.allGroups[i].path.split('/').length;
          $scope.allGroups[i].pathLevel = level - 2;
        }
      }
    }

    $scope.loadGroupsList();

    $scope.repeatSpansByLevel = function (level) {
      var spans = [];
      for (var i = 0; i < level; i++) {
        spans.push(i + 1);
      }
      return spans;
    }

    $scope.hasChildren = function (group) {
      return $scope.allGroups.map(g => g.parent).includes(group.id)
    }

    $scope.expandGroup = function (group) {
      $scope.allGroupsById[group.id].expanded = !$scope.allGroupsById[group.id].expanded
    }

    $scope.groupVisible = function (group) {
      if (!group.parent) {
        return true
      } else {
        var visible = true
        var parentToCheck = $scope.allGroupsById[group.parent]
        while (parentToCheck && visible) {
          visible = parentToCheck.expanded
          parentToCheck = $scope.allGroupsById[parentToCheck.parent]
        }
        return visible
      }
    }

    $scope.goTo = function (href) {
      $window.location.href = href;
    }

    $scope.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    /***** DATA *****/
    userService.getMembers(null, function (users) {
      $scope.allUsers = users;
    }, function (err) {
      $scope.allUsers = [];
    });

    userService.getRoles(null, function (roles) {
      $scope.allRoles = roles;
    }, function (err) {
      $scope.allRoles = [];
    });

    docketService.getTemplates(null, function (templates) {
      $scope.allTemplates = templates;
    }, function (err) {
      $scope.allTemplates = [];
    });

    /*************************************/
    /***** Current Org Functionality *****/
    /*************************************/

    $scope.newOrgGroup = function (parentGroup) {
      if (parentGroup == undefined) {
        parentGroup = $scope.allGroups.find(g => g.parent == null)
      }

      $scope.newGroup = true
      $scope.activeUsers = []
      $scope.invitedUsers = []
      $scope.selectedIndexContainer.selectedIndex = 0
      $scope.view = 'detail';
      $scope.groupEdit = {};
      $scope.groupEdit.orderPrefix = "O";
      $scope.groupEdit.jobPrefix = "J";
      $scope.groupEdit.docketPrefix = "D";
      $scope.groupEdit.invoicePrefix = "INV";

      var timezone = moment.tz.guess();
      if (timezone) {
        $scope.groupEdit.timezone = timezone;
      }
      $scope.groupEdit.timeFormat = '12HR';

      $scope.newGroupHasParent = parentGroup;
      $scope.groupEdit.owners = parentGroup.owners.slice();

      $scope.groupEdit.defaultTemplate = parentGroup.defaultTemplate
    }

    $scope.closeNewGroupModal = function () {
      $scope.groupEdit = null;
    }

    $scope.closeGroupEdit = function () {
      $scope.groupEdit = null;
      $scope.view = 'list';
    }

    $scope.editOrgGroup = function (group) {
      $scope.groupEdit = { loading: true };
      $scope.selectedIndexContainer.selectedIndex = 0
      $scope.newGroup = false
      $scope.view = 'detail';
      userService.getOrganisationGroup(group.id, function (groupFull) {
        $scope.groupEdit = groupFull;
        $scope.groupOriginal = angular.copy(groupFull);
        $scope.loadAllUsers(groupFull);
        /*$scope.newMember = {};
        $scope.groupEdit.membersLoadingError = null;
        // get org group members
        userService.getGroupMembers({ 'sort' : 'first', 'groupId' : group.id }, function(membersUserInfo) {
          getGroupedMembers(groupFull.members, membersUserInfo, function(groupedMembers) {
            $scope.groupEdit.groupedMembers = groupedMembers;
          });
          populateMonitorOwnerStatus($scope.groupEdit, membersUserInfo);
        }, function(err) {
          $scope.groupEdit.groupedMembers = [];
          $scope.groupEdit.membersLoadingError = 'It looks like we had some trouble fetching the list of members for this group. Please try again.';
        });*/
      }, function (err) {
        $scope.groupEdit.loading = false;
        $scope.closeGroupEdit();
        $scope.alertService.presentAutoAlert('getOrgGroup', err);
      });
    }

    $scope.reloadGroupMembers = function (groupEdit) {
      userService.getOrganisationGroup(groupEdit.id, function (groupFull) {
        userService.getGroupMembers({ 'sort': 'first', 'groupId': groupEdit.id }, function (membersUserInfo) {
          getGroupedMembers(groupFull.members, membersUserInfo, function (groupedMembers) {
            groupEdit.groupedMembers = groupedMembers;
          });
        }, function (err) {
          getGroupedMembers(groupFull.members, null, function (groupedMembers) {
            groupEdit.groupedMembers = groupedMembers;
          });
        });
      }, function (err) {
        $scope.alertService.presentAutoAlert('getOrgGroup', err);
      });
    }

    $scope.reloadGroupOwners = function (groupEdit) {
      userService.getOrganisationGroup(groupEdit.id, function (groupFull) {
        groupEdit.owners = groupFull.owners;
      }, function (err) {

      });
    }

    $scope.reloadGroupMonitors = function (groupEdit) {
      userService.getOrganisationGroup(groupEdit.id, function (groupFull) {
        groupEdit.monitors = groupFull.monitors;
      }, function (err) {

      });
    }

    // group members (user/role combo) by user
    var getGroupedMembers = function (membersList, membersUserInfo, cb) {
      var members = [];

      for (var i = 0; i < membersUserInfo.length; i++) {
        var user = membersUserInfo[i];
        var roles = [];
        for (var j = 0; j < membersList.length; j++) {
          if (membersList[j].user.id == user.id) {
            roles.push(membersList[j].role);
          }
        }
        var newMemberItem = { roles: roles, originalRoles: angular.copy(roles), user: user, editing: false };
        members.push(newMemberItem);
      }

      cb(members);
    }

    // populate onDocketbook status of owners list and monitor list
    var populateMonitorOwnerStatus = function (group, usersList) {
      for (var i = 0; i < group.owners.length; i++) {
        for (var j = 0; j < usersList.length; j++) {
          if (group.owners[i].id == usersList[j].id) {
            group.owners[i].onDocketbook = usersList[j].onDocketbook;
            break;
          }
        }
      }

      for (var i = 0; i < group.monitors.length; i++) {
        for (var j = 0; j < usersList.length; j++) {
          if (group.monitors[i].id == usersList[j].id) {
            group.monitors[i].onDocketbook = usersList[j].onDocketbook;
            break;
          }
        }
      }
    }

    $scope.saveOrgGroup = function (group) {
      $scope.loadingGroups = true
      group.loading = true;
      // get diff and save if diffcount > 0
      userService.getGroupDiff($scope.groupOriginal, group, function (diffCount, diff) {
        if (diffCount > 0) {
          if (group.id == null) { // Hack for new org groups - appending currentUser as the owner
            if ($scope.newGroupHasParent != null) {
              diff.parent = $scope.newGroupHasParent.id;
              diff.owners = $scope.newGroupHasParent.owners;
            } else {
              diff.parent = $scope.currentOrgGroup.id;
              diff.owners = [$scope.currentUser.id];
            }
          }

          if ($scope.newGroup && $scope.currentOrg.groups.map(group => group.name).includes($scope.groupEdit.name)) {
            $scope.loadingGroups = false
            group.loading = false

            swal({
              title: "Oops!",
              text: `Group ${group.name} already exists, please choose a different name.`,
              type: "error",
              confirmButtonText: "Ok, got it."
            })

            return;
          }

          userService.saveOrganisationGroup(diff, function (groupUpdated) {
            group.loading = false;
            $scope.closeNewGroupModal();
            $scope.view = 'list';
            accessControl.refreshAndGetAllowedOrganisations(function (orgsList) {
              $scope.allOrganisations = orgsList;
              for (var i = 0; i < $scope.allOrganisations.length; i++) {
                if ($scope.allOrganisations[i].id == $scope.currentOrg.id) {
                  $scope.currentOrg = $scope.allOrganisations[i];
                  $scope.loadGroupsList()
                }
              }
              $scope.loadingGroups = false
            }, function (err) {
            });
          }, function (err) {
            group.loading = false;
            $scope.loadingGroups = false
            $scope.alertService.presentAutoAlert('saveOrgGroup', err);
          });
        } else {
          group.loading = false;
          $scope.loadingGroups = false
          $scope.view = 'list';
          $scope.closeNewGroupModal();
        }
      });
    }

    // change address
    $scope.openEditAddressModal = function () {
      $("#searchAddressModal").fadeIn(200);
    }

    $scope.closeSearchAddressModal = function () {
      $("#searchAddressModal").fadeOut(200);
    }

    // edit member roles
    $scope.editMemberRoles = function (member) {
      member.editing = true;
    }

    $scope.saveMemberRoles = function (member) {
      // generate list of roles to remove
      var rolesToRemove = [];
      for (var i = 0; i < member.originalRoles.length; i++) {
        // check if role has been removed
        var found = false;
        for (var j = 0; j < member.roles.length; j++) {
          if (member.originalRoles[i].id == member.roles[j].id) {
            found = true;
            break;
          }
        }

        if (!found) {
          rolesToRemove.push(member.originalRoles[i]);
        }
      }

      var rolesToAdd = [];
      for (var i = 0; i < member.roles.length; i++) {
        var found = false;
        for (var j = 0; j < member.originalRoles.length; j++) {
          if (member.originalRoles[j].id == member.roles[i].id) {
            found = true;
            break;
          }
        }

        if (!found) {
          rolesToAdd.push(member.roles[i]);
        }
      }

      var failures = [];
      removeRolesForUser(member.user.id, rolesToRemove, 0, failures, function (failuresFilled) {
        addRolesForUser(member.user.id, rolesToAdd, 0, failuresFilled, function (failuresFilled2) {
          member.editing = false;
        });
      });
    }

    var removeRolesForUser = function (userId, rolesToRemove, index, failures, successCb) {
      if (index >= rolesToRemove.length) {
        successCb(failures);
        return;
      }

      userService.removeMemberRoleFromGroup($scope.groupEdit.id, userId, rolesToRemove[index].id, function () {
        removeRolesForUser(userId, rolesToRemove, index + 1, failures, successCb);
      }, function (err) {
        failures.push(err);
        removeRolesForUser(userId, rolesToRemove, index + 1, failures, successCb);
      });
    }

    var addRolesForUser = function (userId, rolesToAdd, index, failures, successCb) {
      if (index >= rolesToAdd.length) {
        successCb(failures);
        return;
      }

      var newMember = { 'role': rolesToAdd[index].id, 'user': userId };

      userService.addMemberToGroup($scope.groupEdit.id, newMember, function () {
        addRolesForUser(userId, rolesToAdd, index + 1, failures, successCb);
      }, function (err) {
        failures.push(err);
        addRolesForUser(userId, rolesToAdd, index + 1, failures, successCb);
      });
    }

    // Get Resource Type Object From Given ID
    $scope.getResTypeFromId = function (id) {
      if (id.id == null) {
        for (var i = 0; i < $scope.allResourceTypes.length; i++) {
          if ($scope.allResourceTypes[i].id == id) {
            return $scope.allResourceTypes[i];
          }
        }
      } else {
        return id;
      }

      return null;
    }

    // Show list view - close configure views
    $scope.showItemList = function () {
      $scope.mode = 'list';
      $scope.groupConfigure = {};
    }

    /********************/
    /* Group File Codes */
    /********************/

    $scope.fileCodes = {};
    $scope.fileCodes.mode = 'list';
    $scope.fileCodes.listLoading = false;
    $scope.fileCodes.selected = [];
    $scope.fileCodes.importSelected = [];
    $scope.fileCodes.query = {
      limit: 10,
      page: 1,
      sort: 'fileCode'
    };
    $scope.fileCodes.listCount = 0;

    $scope.loadFilingList = function () {
      $scope.promise = $q(function (resolve, reject) {
        // Get templates from docketService
        var queryParams = {};
        queryParams.limit = $scope.fileCodes.query.limit;
        queryParams.offset = $scope.fileCodes.query.limit * ($scope.fileCodes.query.page - 1);
        queryParams.sort = $scope.fileCodes.query.order;
        queryParams.orgGroupId = $scope.groupEdit.id;
        docketService.getFileCodes(queryParams, function (fileCodes) {
          $scope.fileCodes.allFileCodes = fileCodes;
          if (queryParams.offset <= 0 && fileCodes.length < queryParams.limit) {
            $scope.fileCodes.listCount = fileCodes.length;
          } else {
            $scope.fileCodes.listCount = queryParams.offset + (queryParams.limit + 1);
          }
          resolve('Done');
        }, function (error) {
          $scope.fileCodes.allFileCodes = [];
          reject('Error');
        });
      });
    }

    //$scope.loadFilingList();

    $scope.newFileCode = function () {
      $scope.fileCodes.fileCodeEdit = {};
      $("#fileCodeModal").fadeIn(100);
    }

    $scope.editFileCode = function (fileCode) {
      $("#fileCodeModal").fadeIn(100);
      $scope.fileCodes.fileCodeEdit = fileCode;
    }

    $scope.saveFileCodeAddAnother = function (fileCode) {
      // saveFileCode
      fileCode.loading = true;
      fileCode.orgGroupId = $scope.groupEdit.id;
      docketService.saveFileCode(fileCode, function () {
        fileCode.loading = false;
        $scope.fileCodes.fileCodeEdit = {};
      }, function (err) {
        fileCode.loading = false;
        $scope.alertService.presentAutoAlert('saveFileCode', err);
      });
    }

    $scope.saveFileCode = function (fileCode) {
      fileCode.loading = true;
      fileCode.orgGroupId = $scope.groupEdit.id;
      docketService.saveFileCode(fileCode, function () {
        fileCode.loading = false;
        $scope.closeFileCodeModal();
        $scope.loadFilingList();
      }, function (err) {
        fileCode.loading = false;
        $scope.alertService.presentAutoAlert('saveFileCode', err);
      });
    }

    $scope.deleteSelectedFileCodes = function () {
      var count = $scope.fileCodes.selected.length;
      swal({
        title: "Are you sure?",
        text: count + " file codes will be deleted.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          docketService.deleteBulkFileCodes($scope.groupEdit.id, $scope.fileCodes.selected, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('deleteBulkFileCodes', { status: 202, requestName: 'Delete bulk file codes - failures ' + failures.length + ' of ' + $scope.fileCodes.selected.length });
              $scope.loadFilingList();
            } else {
              $scope.alertService.presentAutoAlert('deleteBulkFileCodes', { status: 200 });
              $scope.loadFilingList();
            }
          });
        }
      });
    }

    $scope.closeFileCodeModal = function () {
      $("#fileCodeModal").fadeOut(100);
    }

    $scope.openImportModal = function () {
      $("#importModal").fadeIn(100);
      $scope.fileCodes.mode = 'import';
      $scope.fileCodes.fileCodeImport = { 'loading': false };
    }

    $scope.cancelImport = function () {
      $scope.closeImportModal();
      $scope.fileCodes.mode = 'list';
      $scope.fileCodes.importList = [];
    }

    $scope.closeImportModal = function () {
      $("#importModal").fadeOut(100);
    }

    $scope.importFileCodesFromFile = function (fileToUpload) {
      $scope.fileCodes.fileCodeImport.loading = true;

      Upload.upload({
        url: '/v1/parse',
        data: { file: fileToUpload },
        withCredentials: true
      }).then(function (resp) {
        $scope.parseFileCodesForImport(resp.data);
      }, function (resp) {
        $scope.alertService.presentAutoAlert('readFile', resp);
      });
    }

    $scope.parseFileCodesForImport = function (importData) {
      var fileCodesList = [];
      $scope.fileCodes.importSelected = [];

      for (var i = 0; i < importData.length; i++) {
        for (var j = 0; j < importData[i].data.length; j++) {
          var newFileCode = {};
          newFileCode.fileCode = String(importData[i].data[j][0]);
          newFileCode.fileName = String(importData[i].data[j][1]);
          newFileCode.costCode = String(importData[i].data[j][2]);
          newFileCode.systemCodes = importData[i].data[j][3];

          if (newFileCode.fileCode != '' && newFileCode.fileCode != null) {
            var matchedFileCode = $scope.findExistingFileCode(newFileCode.fileCode);
            if (matchedFileCode) {
              newFileCode.status = 'Update';
              newFileCode.uniqueIdentifier = matchedFileCode.uniqueIdentifier;
            } else {
              newFileCode.status = 'New';
            }
          } else {
            newFileCode.error = true;
            newFileCode.status = 'New';
          }

          $scope.validateFileCodeItem(newFileCode);
          newFileCode.importId = uuid.v4();
          $scope.fileCodes.importSelected.push(newFileCode);
          fileCodesList.push(newFileCode);
        }
      }
      $scope.fileCodes.importList = fileCodesList;
      $scope.closeImportModal();
      $scope.fileCodes.fileCodeImport.loading = false;
    }

    $scope.findExistingFileCode = function (fileCode) {
      if (fileCode == null || fileCode == '') {
        return null;
      }

      for (var i = 0; i < $scope.fileCodes.allFileCodes.length; i++) {
        if ($scope.fileCodes.allFileCodes[i].fileCode == fileCode) {
          // found a fileCode with the fileCode as given - exists
          return $scope.fileCodes.allFileCodes[i];
        }
      }

      return null;
    }

    $scope.bulkImportFileCodes = function () {
      var importList = $scope.fileCodes.importSelected;
      var filecodesSave = [];
      for (var i = 0; i < importList.length; i++) {
        if (importList[i].selected) {
          var fileCode = {};
          fileCode.fileCode = importList[i].fileCode;
          fileCode.fileName = importList[i].fileName;
          fileCode.costCode = importList[i].costCode;
          fileCode.organisation = $scope.currentOrg.id;
          fileCode.organisationGroup = $scope.currentOrgGroup.id;
          if (importList[i].uniqueIdentifier) {
            fileCode.uniqueIdentifier = importList[i].uniqueIdentifier;
          }
          //TODO: system codes

          filecodesSave.push(fileCode);
        }
      }

      docketService.importFileCodes($scope.groupEdit.id, filecodesSave, function (resp) {
        var codesCreated = resp.codes;
        var codeExceptions = resp.exceptions;
        $scope.fileCodes.mode = 'list';
        $scope.loadFilingList();
        var text = codesCreated.length + " file codes were successfully imported."
        $scope.alertService.presentAlert("success", "Import Complete!", text);
        $scope.fileCodes.importList = [];
      }, function (err) {
        $scope.alertService.presentAutoAlert('importFileCodes', err);
      });
    }

    $scope.validateFileCodeItem = function (fileCode) {
      var error = false;
      if (fileCode.fileCode == null || fileCode.fileCode == '') {
        error = true;
      }

      if (fileCode.fileName == null || fileCode.fileName == '') {
        error = true;
      }

      if (fileCode.costCode == null || fileCode.costCode == '') {
        error = true;
      }

      if (error) {
        fileCode.error = error;
        fileCode.selected = false;
      } else {
        fileCode.error = false;
        fileCode.selected = true;
      }

    }

    $scope.removeCodeFromImportList = function (fileCode, importList) {
      var index = importList.indexOf(fileCode);
      if (index != -1) {
        importList.splice(index, 1);
      }
    }

    $scope.toggleRowItem = function (item) {
      if (item.selected) {
        item.selected = false;
      } else {
        item.selected = true;
      }
    }

    /***************/
    /* Group Users */
    /***************/

    $scope.globalAdministrators = {};
    for (var i = 0; i < $scope.currentOrg.globalAdministrators.length; i++) {
      $scope.globalAdministrators[$scope.currentOrg.globalAdministrators[i]] = $scope.currentOrg.globalAdministrators[i];
    }

    $scope.activeUsers = [];
    $scope.invitedUsers = [];

    $scope.loadAllUsers = function (groupFull) {
      $scope.activeUsers = [];
      $scope.invitedUsers = [];
      // set out monitors list
      $scope.groupMonitors = {};
      for (var i = 0; i < groupFull.monitors.length; i++) {
        $scope.groupMonitors[groupFull.monitors[i].id] = true;
      }
      userService.getGroupMembers({ 'sort': 'first', 'groupId': groupFull.id }, function (membersUserInfo) {
        getGroupedMembers(groupFull.members, membersUserInfo, function (groupedMembers) {
          for (var i = 0; i < groupedMembers.length; i++) {
            if (groupedMembers[i].user.onDocketbook == true) {
              $scope.activeUsers.push(groupedMembers[i]);
            } else {
              $scope.invitedUsers.push(groupedMembers[i]);
            }
          }
        });
      }, function (err) {
        console.error('could not load all users', err);
      });
    }

    // group members (user/role combo) by user
    var getGroupedMembers = function (membersList, membersUserInfo, cb) {
      var members = [];

      for (var i = 0; i < membersUserInfo.length; i++) {
        var user = membersUserInfo[i];
        var roles = [];
        for (var j = 0; j < membersList.length; j++) {
          if (membersList[j].user.id == user.id) {
            roles.push(membersList[j].role);
          }
        }
        var newMemberItem = { roles: roles, originalRoles: angular.copy(roles), user: user, editing: false };
        if ($scope.globalAdministrators[user.id]) {
          newMemberItem.isGlobalAdmin = true;
        } else {
          newMemberItem.isGlobalAdmin = false;
        }
        if ($scope.groupMonitors[user.id]) {
          newMemberItem.isMonitor = true;
        } else {
          newMemberItem.isMonitor = false;
        }

        newMemberItem.owner = $scope.groupEdit.owners.map(owner => owner.id).includes(user.id)

        if (newMemberItem.user.emailAddress.indexOf("users.docketbook.io") !== -1) {
          newMemberItem.user.displayEmailAddress = `0${newMemberItem.user.emailAddress.split("@")[0].substring(3)}`;
        } else {
          newMemberItem.user.displayEmailAddress = newMemberItem.user.emailAddress;
        }
        if (accessControl.isSampleCompany()) {
          const user = newMemberItem.user;
          if ((user.name.first === "Chris") && (user.name.last === "Digger")) {
            newMemberItem.user.displayEmailAddress = "chris.digger@fakeaddress.com"
          } else if ((user.name.first === "John") && (user.name.last === "Trucks")) {
            newMemberItem.user.displayEmailAddress = "john.trucks@fakeaddress.com"
          } else if ((user.name.first === "Steve") && (user.name.last === "Dozer")) {
            newMemberItem.user.displayEmailAddress = "steve.dozer@fakeaddress.com"
          }
        }
        members.push(newMemberItem);
      }

      cb(members);
    }

    $scope.getGroupRoles = function (member) {
      var extraRoles = []
      if (member.isGlobalAdmin) {
        extraRoles.push('Super User')
      }
      if (member.isMonitor) {
        extraRoles.push('Monitor')
      }
      if (!member.isGlobalAdmin && member.owner) {
        extraRoles.push('Administrator')
      }
      if (member.isGlobalAdmin) {
        return extraRoles.join(', ')
      } else {
        return [...extraRoles, ...member.roles.map(role => role.name)].join(', ')
      }
    }



    /* OLD */

    // Remove a member(GroupAssignment) from group
    $scope.removeMemberFromGroup = function (member, group) {
      userService.removeMemberFromGroup(group.id, member.user.id, function (success) {
        for (var i = 0; i < group.groupedMembers.length; i++) {
          if (group.groupedMembers[i].user.id == member.user.id) {
            group.groupedMembers.splice(i, 1);
            break;
          }
        }
      }, function (err) {
        $scope.alertService.presentAutoAlert('removeGroupMember', err);
      });
    }

    // Remove an owner from group
    $scope.removeOwnerFromGroup = function (owner, group) {
      userService.removeOwnerFromGroup(group.id, owner.id, function (success) {
        $scope.reloadGroupOwners(group);
      }, function (err) {
        $scope.alertService.presentAutoAlert('removeGroupOwner', err);
      });
    }

    // Remove an monitor from group
    $scope.removeMonitorFromGroup = function (monitor, group) {
      userService.removeMonitorFromGroup(group.id, monitor.id, function (success) {
        $scope.reloadGroupMonitors(group);
      }, function (err) {
        $scope.alertService.presentAutoAlert('removeGroupMonitor', err);
      });
    }

    // Add a new member(GroupAssignment) to group
    $scope.addMemberToGroup = function (newMember, group) {
      var newMemberToAdd = {};
      newMemberToAdd.role = newMember.role.id;

      if (newMember.user != null) {
        // Add user using actual user object
        newMemberToAdd.user = newMember.user.id;
      } else if (newMember.emailAddress != null) {
        // Add user using email address
        newMemberToAdd.emailAddress = newMember.emailAddress;
      } else {
        // No user detail supplied - cannot continue
        alert('no details for the user were supplied, try again.');
        return;
      }

      userService.addMemberToGroup(group.id, newMemberToAdd, function () {
        $scope.editOrgGroup(group);
      }, function (err) {
        $scope.alertService.presentAutoAlert('addGroupMember', err);
      });
    }

    // Add a role to a member
    $scope.addRoleToMember = function (member) {
      var existingRoles = [];
      for (var i = 0; i < member.roles.length; i++) {
        existingRoles.push(member.roles[i].id);
      }
      $scope.roleSelectFromParent(existingRoles, function (rolesSelected) {
        if (rolesSelected != null) {
          for (var i = 0; i < rolesSelected.length; i++) {
            member.roles.push(rolesSelected[i]);
          }
        }
      });
    }

    // Add people to group
    $scope.addMembersToGroup = function (groupEdit) {
      // get list of existing users for this group
      var existingMembers = [];
      for (var i = 0; i < groupEdit.groupedMembers.length; i++) {
        existingMembers.push(groupEdit.groupedMembers[i].user.id);
      }
      $scope.selectOrgPeopleFromParent(existingMembers, function (people) {
        if (people != null) {
          $scope.roleSelectFromParent(null, function (rolesSelected) {
            if (rolesSelected != null) {
              var roles = [];
              for (var i = 0; i < rolesSelected.length; i++) {
                roles.push(rolesSelected[i].id);
              }
              var membersToAdd = [];
              for (var i = 0; i < people.length; i++) {
                var person = { 'user': people[i].id, roles: roles };
                membersToAdd.push(person);
              }

              userService.assignMembersToGroup(groupEdit.id, membersToAdd, function (success) {
                $scope.reloadGroupMembers(groupEdit);
              }, function (err) {
                $scope.alertService.presentAutoAlert('addGroupMember', err);
              });
            }
          });
        }
      });
    }

    // Add owners to group
    $scope.addOwnersToGroup = function (groupEdit) {
      // get list of existing users for this group
      var existingOwners = [];
      for (var i = 0; i < groupEdit.owners.length; i++) {
        existingOwners.push(groupEdit.owners[i].id);
      }
      $scope.selectOrgPeopleFromParent(existingOwners, function (people) {
        if (people != null) {
          var membersToAdd = [];
          for (var i = 0; i < people.length; i++) {
            var person = { 'user': people[i].id, roles: ['owner'] };
            membersToAdd.push(person);
          }

          userService.assignMembersToGroup(groupEdit.id, membersToAdd, function (success) {
            $scope.reloadGroupOwners(groupEdit);
          }, function (err) {
            $scope.alertService.presentAutoAlert('addGroupOwner', err);
          });
        }
      });
    }

    // Add monitors to group
    $scope.addMonitorsToGroup = function (groupEdit) {
      // get list of existing users for this group
      var existingMonitors = [];
      for (var i = 0; i < groupEdit.monitors.length; i++) {
        existingMonitors.push(groupEdit.monitors[i].id);
      }
      $scope.selectOrgPeopleFromParent(existingMonitors, function (people) {
        if (people != null) {
          var membersToAdd = [];
          for (var i = 0; i < people.length; i++) {
            var person = { 'user': people[i].id, roles: ['monitor'] };
            membersToAdd.push(person);
          }

          userService.assignMembersToGroup(groupEdit.id, membersToAdd, function (success) {
            $scope.reloadGroupMonitors(groupEdit);
          }, function (err) {
            $scope.alertService.presentAutoAlert('addGroupMonitor', err);
          });
        }
      });
    }

    // Inviting new members
    $scope.inviteMembersToGroup = function () {
      $("#inviteMembersModal").fadeIn(200);
      $scope.newMemberInvitesLoading = false;
      $scope.inviteMembers = { singleGroup: true };
      $scope.newMemberInvites = [{}];
    }

    $scope.addBlankInvitee = function () {
      $scope.newMemberInvites.push({});
    }

    $scope.removeInvitee = function (invitee) {
      $scope.newMemberInvites.splice($scope.newMemberInvites.indexOf(invitee), 1);
    }

    $scope.closeInviteMembers = function () {
      $("#inviteMembersModal").fadeOut(200);
    }

    $scope.inviteMembersContinue = function () {
      $scope.newMemberInvitesLoading = true;
      var invitesArray = [];
      for (var i = 0; i < $scope.newMemberInvites.length; i++) {
        var roleAdd = "";
        roleAdd = $scope.newMemberInvites[i].role.id;
        var rolesToAdd = [];
        rolesToAdd.push(roleAdd);
        if ($scope.newMemberInvites[i].addAsMonitor == true) {
          rolesToAdd.push('monitor');
        }
        var newInvite = { 'emailAddress': $scope.newMemberInvites[i].emailAddress.replace(/\s/g, ''), 'roles': rolesToAdd, 'firstName': $scope.newMemberInvites[i].firstName, 'lastName': $scope.newMemberInvites[i].lastName };
        invitesArray.push(newInvite);
      }

      userService.assignMembersToGroup($scope.groupEdit.id, invitesArray, function (success) {
        $scope.loadAllUsers($scope.groupEdit);
        $scope.closeInviteMembers();
      }, function (err) {
        $scope.newMemberInvitesLoading = false;
        $scope.alertService.presentAutoAlert('addGroupMembers', err);
      });
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/companySettings/groups.js